import { useState, useEffect, useMemo } from 'react';
import InputMask from 'react-input-mask';
import api from '../../service/api';
import styles from './index.module.css';
import { Link } from 'react-router-dom';
import NavbarComponent from '../../components/Navbar/NavbarComponent';
import NavMenuComponent from '../../components/NavMenu/NavMenuComponent';
import ModalComponent from '../../components/Modal/ModalComponent';
import { Row, Col, Form, FormGroup, Label, Input, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useFormik } from 'formik';

function CadastroEmpresa() {
    const [isRegister, setIsRegister] = useState(false);
    const [buscaEstado, setBuscaEstado] = useState("");
    const [estadosFiltrados, setEstadosFiltrados] = useState([]);
    const [errorRegister, setErrorRegister] = useState("");
    const estados = useMemo(() => [
        "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
        "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
        "RS", "RO", "RR", "SC", "SP", "SE", "TO"
    ], []);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
        },
        validateOnBlur: true,
        validate: values => {
            const errors = {};

            if (!values.nomeFantasia) {
                errors.nomeFantasia = "O campo é obrigatório.";
            } else if (values.nomeFantasia.length < 3) {
                errors.nomeFantasia = "O Nome Fantasia deve conter mais de 3 letras.";
            }

            if (!values.razaoSocial) {
                errors.razaoSocial = "O campo é obrigatório.";
            } else if (values.razaoSocial.length < 3) {
                errors.razaoSocial = "A Razão Social deve conter mais de 3 letras.";
            }

            const cnpj_teste = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
            if (!values.cnpj) {
                errors.cnpj = "O campo é obrigatório.";
            } else if (!cnpj_teste.test(values.cnpj)) {
                errors.cnpj = "Digite um CNPJ válido 00.000.000/0001-00.";
            }

            if (!values.cep) {
                errors.cep = "O campo é obrigatório.";
            } else if (!/^\d{5}-?\d{3}$/.test(values.cep)) {
                errors.cep = "O CEP deve conter apenas números.";
            }


            if (!values.rua) {
                errors.rua = "O campo é obrigatório.";
            } else if (values.rua.length < 3) {
                errors.rua = "A Rua deve conter mais de 3 letras.";
            }

            if (!values.numero) {
                errors.numero = "O campo é obrigatório.";
            } else if (!/^\d+$/.test(values.numero)) {
                errors.numero = "O campo Número deve conter apenas números.";
            }

            if (!values.bairro) {
                errors.bairro = "O campo é obrigatório.";
            } else if (values.bairro.length < 3) {
                errors.bairro = "O Bairro deve conter mais de 3 letras.";
            }

            if (!values.cidade) {
                errors.cidade = "O campo é obrigatório.";
            } else if (values.cidade.length < 3) {
                errors.cidade = "A Cidade deve conter mais de 3 letras.";
            }

            if (!values.estado) {
                errors.estado = "O campo é obrigatório.";
            } else if (values.estado.length > 2) {
                errors.estado = "O Estado deve conter apenas de 2 letras.";
            }

            if (!values.pais) {
                errors.pais = "O campo é obrigatório.";
            } else if (values.pais.length < 3) {
                errors.pais = "O Pais deve conter mais de 3 letras.";
            }

            return errors;
        },
        onSubmit: (values) => {
            const errors = formik.validateForm(values);

            if (Object.keys(errors).length > 0) {
                formik.setErrors(errors);
                return;
            }

            setErrorRegister("");

            api.post('empresa', {
                nomeFantasia: values.nomeFantasia,
                razaoSocial: values.razaoSocial,
                cnpj: values.cnpj,
                cep: values.cep,
                rua: values.rua,
                numero: values.numero,
                bairro: values.bairro,
                cidade: values.cidade,
                estado: values.estado,
                pais: values.pais,
                ativo: 'true'
            }).then((response) => {
                setIsRegister(true);
                console.log(response);
            }).catch((error) => {
                if (error.response) {
                    setErrorRegister(error.response.status);
                    console.log(error.response);
                }
            });
        }
    });

    useEffect(() => {
        const lowerBuscaEstado = buscaEstado.toLocaleLowerCase();

        setEstadosFiltrados(estados.filter((est) => est.toLocaleLowerCase().includes(lowerBuscaEstado)));
    }, [buscaEstado, estados]);

    return (
        <div className={styles.mainDiv}>
            <NavbarComponent />
            <NavMenuComponent />

            {errorRegister ? (
                <ModalComponent
                    isOpen={true}
                    onClose={() => setErrorRegister("")}
                    mensagem="Não foi possivel concluir o cadastro!"
                    icon="Erro"
                />
            ) : null}
            {isRegister ? (
                <ModalComponent
                    isOpen={true}
                    onClose={() => setIsRegister(false)}
                    mensagem="Empresa cadastrada com sucesso"
                    icon="Sucesso"
                    link="empresas"
                />
            ) : null}

            <div className={styles.route}>
                <Link to="/" className={styles.link}> Home </Link> &gt;
                <span> Cadastrar Empresa </span>
            </div>

            <div className={styles.title}>
                Cadastrar Empresa
            </div>

            <div responsive className={styles.container}>
                <div className={styles.divDadosGerais}>
                    Dados Gerais
                </div>

                <div className={styles.linha} />
                
                <Form inline onSubmit={formik.handleSubmit}>
                    <Row xs="4">
                        <Col>
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="nomeFantasia" className={styles.label}>Nome Fantasia *</Label>

                                <Input
                                    className={formik.errors.nomeFantasia ? styles.errorInput : null}
                                    id="nomeFantasia"
                                    bsSize="sm"
                                    name="nomeFantasia"
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.nomeFantasia}
                                />

                                {formik.errors.nomeFantasia ? <div className={styles.errorDiv}>{formik.errors.nomeFantasia}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="razaoSocial" className={styles.label}>Razão Social *</Label>

                                <Input
                                    className={formik.errors.razaoSocial ? styles.errorInput : null}
                                    id="razaoSocial"
                                    bsSize="sm"
                                    name="razaoSocial"
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.razaoSocial}
                                />

                                {formik.errors.razaoSocial ? <div className={styles.errorDiv}>{formik.errors.razaoSocial}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="cnpj" className={styles.label}>CNPJ *</Label>

                                <InputMask
                                    mask="99.999.999/9999-99"
                                    id="cnpj"
                                    bsSize="sm"
                                    name="cnpj"
                                    className={`${formik.errors.cnpj ? styles.errorInput : ''}`}
                                    onChange={formik.handleChange}
                                    value={formik.values.cnpj}
                                >
                                    {(inputProps) => <Input {...inputProps} type="text" />}
                                </InputMask>

                                {formik.errors.cnpj ? <div className={styles.errorDiv}>{formik.errors.cnpj}</div> : null}
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className={styles.divContato}>Endereço</div>

                    <div className={styles.linha} />

                    <Row xs="4">
                        <Col>
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="cep" className={styles.label}>CEP *</Label>

                                <InputMask
                                    mask="99999-999"
                                    id="cep"
                                    bsSize="sm"
                                    name="cep"
                                    className={formik.errors.cep ? styles.errorInput : null}
                                    onChange={formik.handleChange}
                                    value={formik.values.cep}
                                    type="text"
                                >
                                    {(inputProps) => <Input {...inputProps} type="text" />}
                                </InputMask>

                                {formik.errors.cep ? <div className={styles.errorDiv}>{formik.errors.cep}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="rua" className={styles.label}>Rua *</Label>

                                <Input
                                    className={formik.errors.rua ? styles.errorInput : null}
                                    id="rua"
                                    bsSize="sm"
                                    name="rua"
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.rua}
                                />

                                {formik.errors.rua ? <div className={styles.errorDiv}>{formik.errors.rua}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="numero" className={styles.label}>Número *</Label>

                                <Input
                                    className={formik.errors.numero ? styles.errorInput : null}
                                    id="numero"
                                    bsSize="sm"
                                    name="numero"
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.numero}
                                />

                                {formik.errors.numero ? <div className={styles.errorDiv}>{formik.errors.numero}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="bairro" className={styles.label}>Bairro *</Label>

                                <Input
                                    className={formik.errors.bairro ? styles.errorInput : null}
                                    id="bairro"
                                    bsSize="sm"
                                    name="bairro"
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.bairro}
                                />

                                {formik.errors.bairro ? <div className={styles.errorDiv}>{formik.errors.bairro}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="cidade" className={styles.label}>Cidade *</Label>

                                <Input
                                    className={formik.errors.cidade ? styles.errorInput : null}
                                    id="cidade"
                                    bsSize="sm"
                                    name="cidade"
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.cidade}
                                />

                                {formik.errors.cidade ? <div className={styles.errorDiv}>{formik.errors.cidade}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="estado" className={styles.label}>Estado *</Label>

                                <UncontrolledDropdown className={formik.errors.estado ? styles.errorInput : styles.dropdown}>
                                    <DropdownToggle caret nav className={styles.dropdownToggle}>
                                        {formik.values.estado || "Selecione uma opção"}
                                    </DropdownToggle>

                                    <DropdownMenu>
                                        <Input
                                            bsSize="sm"
                                            placeholder="Buscar"
                                            className={styles.inputBusca}
                                            type="text"
                                            value={buscaEstado}
                                            onChange={(ev) => setBuscaEstado(ev.target.value)}
                                        />

                                        <DropdownItem divider />

                                        {buscaEstado
                                            ? estadosFiltrados.map((estado, index) => (
                                                <DropdownItem
                                                    key={`estado-${index}`}
                                                    id={`estado-${index}`}
                                                    className={styles.dropdownItem}
                                                    bsSize="sm"
                                                    name="estado"
                                                    value={estado}
                                                    onClick={() => formik.setFieldValue('estado', estado)}
                                                >
                                                    {estado}
                                                </DropdownItem>
                                            ))
                                            : estados.map((estado, index) => (
                                                <DropdownItem
                                                    key={`estado-${index}`}
                                                    id={`estado-${index}`}
                                                    className={styles.dropdownItem}
                                                    bsSize="sm"
                                                    name="estado"
                                                    value={estado}
                                                    onClick={() => formik.setFieldValue('estado', estado)}
                                                >
                                                    {estado}
                                                </DropdownItem>
                                            ))}
                                    </DropdownMenu>
                                </UncontrolledDropdown>

                                {formik.errors.estado && (
                                    <div className={styles.errorDiv}>{formik.errors.estado}</div>
                                )}
                            </FormGroup>
                        </Col>


                        <Col>
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="pais" className={styles.label}>País *</Label>

                                <Input
                                    className={formik.errors.pais ? styles.errorInput : null}
                                    id="pais"
                                    bsSize="sm"
                                    name="pais"
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.pais}
                                />

                                {formik.errors.pais ? <div className={styles.errorDiv}>{formik.errors.pais}</div> : null}
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className={styles.divButton}>
                        <Link to='/empresas'><Button bsSize="sm" className={styles.buttonCacelar}>Cancelar</Button></Link>
                        <Button bsSize="sm" type="submit" className={styles.buttonCadastrar} disabled={!(formik.isValid && formik.dirty)}>Cadastrar</Button>
                    </div>
                </Form>
            </div>
        </div >
    );
}

export default CadastroEmpresa;
